import { useLazyQuery } from '@apollo/client';
import { ContentTypeEnum } from 'constants-content';
import { getServiceRequestContentId } from 'graphql-queries';
import { useCallback, useMemo } from 'react';

export class GetContentForServiceRequestError extends Error {}

export const useGetContentForServiceRequest = () => {
  const [executeQuery, { data, loading, error }] = useLazyQuery(
    getServiceRequestContentId
  );

  const fetchServiceRequestContent = useCallback(
    (channelId: string) => {
      executeQuery({
        variables: {
          channelId,
          search: {
            type: {
              any: ContentTypeEnum.WorkOrder,
            },
          },
        },
      });
    },
    [executeQuery]
  );

  const wrappedError = useMemo(
    () => (error ? new GetContentForServiceRequestError(error.message) : undefined),
    [error]
  );

  return {
    fetchServiceRequestContent,
    contentId: data?.serviceRequestContentId,
    loading,
    error: wrappedError,
  };
};
